import { initialPagedData, PagedApiData } from '@app/core/models/PagedApiData';
import { WhatsappMessageHistory } from '@app/communications/models/responses/whatsapp-message-history';
import { ApiData, createApiDataInitialState } from '@app/core/models/api-data';
import { UserMessagingMetadata } from '@app/communications/models/responses/user-messaging-metadata';
import { MessageHistory } from '@app/communications/models/responses/message-history';
import { WhatsappConversationDetails } from '@app/communications/models/responses/whatsapp-conversation-details';
import { Message } from '@app/communications/models/responses/message';
import { SendWhatsAppMessageRequest } from '@app/communications/models/requests/send-whatsapp-message-request';
import { ClaimContactDetails } from '@app/communications/models/responses/claim-contact-details';
import { AllowedWhatsAppFileTypes } from '@app/communications/models/responses/allowed-whatsapp-file-types';
import { TemplatedMessage } from '@app/communications/models/responses/templated-message';
import { SystemContact } from '@app/communications/models/responses/system-contact';
import { PensionsBeneficiaryContactDetails } from '@app/communications/models/responses/pensions-beneficiary-contact-details';
import { EducationAssistanceBeneficiaryContactDetails } from '@app/communications/models/responses/education-assistance-beneficiary-contact-details';
import {
  defaultNotification,
  UnreadWhatsappConversationsNotification,
} from '@app/communications/models/responses/unread-whatsapp-conversations.notification';
import {
  initialTableState,
  TableDataState,
} from '@app/shared/table/helpers/generic-table-state';
import { CommunicationTables } from '@app/communications/models/enums/communication-tables.enum';
import { PendingCustomClaimSms } from '@app/communications/models/responses/pending-custom-claim-sms';

export interface CommunicationsState extends TableDataState {
  claimContacts: ApiData<ClaimContactDetails[]>;
  isSendingOptIn: boolean;
  isStartingConversation: boolean;
  messageHistory: PagedApiData<MessageHistory>;
  smsMessageHistory: PagedApiData<MessageHistory>;
  pensionsBeneficiaryContacts: ApiData<PensionsBeneficiaryContactDetails[]>;
  sendClaimSmsModal: {
    selectedSmsTemplatePreview: string;
  };
  sendPensionsBeneficiarySmsModal: {
    selectedSmsTemplatePreview: string;
  };
  systemContacts: ApiData<SystemContact[]>;
  userMessagingMetadata: ApiData<UserMessagingMetadata>;
  whatsApp: {
    selectedConversationDetails: ApiData<WhatsappConversationDetails>;
    myConversations: PagedApiData<WhatsappMessageHistory>;
    conversationMessages: PagedApiData<Message>;
    sendMessage: ApiData<SendWhatsAppMessageRequest>;
    allowedFileTypes: ApiData<AllowedWhatsAppFileTypes>;
    templatedMessage: ApiData<TemplatedMessage>;
    sendTemplateMessage: ApiData<SendWhatsAppMessageRequest>;
  };
  isSendingSms: boolean;
  educationAssistanceBeneficiaryContacts: ApiData<
    EducationAssistanceBeneficiaryContactDetails[]
  >;
  whatsAppUnreadConversations: UnreadWhatsappConversationsNotification;
  isCreatingUnreadWhatsappConversationNotifications: boolean;
  isActioningCustomSMSRequest: boolean;
  pendingCustomClaimSMS: ApiData<PendingCustomClaimSms>;
}

export const initialCommunicationsState: CommunicationsState = {
  messageHistory: initialPagedData,
  smsMessageHistory: initialPagedData,
  userMessagingMetadata: createApiDataInitialState(),
  whatsApp: {
    myConversations: initialPagedData,
    selectedConversationDetails: createApiDataInitialState(),
    conversationMessages: initialPagedData,
    sendMessage: createApiDataInitialState(),
    allowedFileTypes: createApiDataInitialState(),
    templatedMessage: createApiDataInitialState(),
    sendTemplateMessage: createApiDataInitialState(),
  },
  sendClaimSmsModal: {
    selectedSmsTemplatePreview: '',
  },
  claimContacts: createApiDataInitialState(),
  isStartingConversation: false,
  isSendingOptIn: false,
  systemContacts: createApiDataInitialState(),
  pensionsBeneficiaryContacts: createApiDataInitialState(),
  sendPensionsBeneficiarySmsModal: {
    selectedSmsTemplatePreview: '',
  },
  isSendingSms: false,
  educationAssistanceBeneficiaryContacts: createApiDataInitialState(),
  whatsAppUnreadConversations: defaultNotification,
  isCreatingUnreadWhatsappConversationNotifications: false,
  dataTables: initialTableState(CommunicationTables.CustomClaimSmsRequests),
  isActioningCustomSMSRequest: false,
  pendingCustomClaimSMS: createApiDataInitialState(),
};
